<!-- <div>
    <div class="button" (click)='sendMessage("Services")'>Services</div>
    <div class="button" (click)='sendMessage("Locations")'>Locations</div>
    <div class="button" (click)='sendMessage("Book Appointment")'>Book Appointment</div>
</div> -->

<div class='tab' *ngFor="let message of messages" [innerHTML]="message.name">
    <!-- {{message.name}} -->
</div>